import React from 'react';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { IIndustryBlend } from 'utils/types';
import { getIndustryBlends } from 'utils/api';
import { NoData } from 'components/Benchmarks';
import { LoaderWrapper } from './Benchmarks.styles';
import Benchmarks from './Benchmarks';

interface IState {
  isLoading: boolean;
  industryBlends: null | IIndustryBlend[];
}

export class BenchmarksContainer extends React.Component<{}, IState> {
  state = {
    isLoading: false,
    industryBlends: null as IState['industryBlends'],
  };

  componentDidMount() {
    this.fetchIndustryBlends();
  }

  fetchIndustryBlends = () => {
    this.setState({
      isLoading: true,
    });

    getIndustryBlends().then((industryBlends: IIndustryBlend[]) => {
      this.setState({
        isLoading: false,
        industryBlends,
      });
    });
  };

  render() {
    const { isLoading, industryBlends } = this.state;
    const isIndustryBlendDefined =
      industryBlends &&
      industryBlends.length > 0 &&
      industryBlends.find((blend) => blend.isActive);

    if (isLoading) {
      return (
        <LoaderWrapper>
          <ApLoaderDefault loaderText={() => <ApLoaderText />} />
        </LoaderWrapper>
      );
    }

    if (!isIndustryBlendDefined) {
      return <NoData />;
    }

    return <Benchmarks />;
  }
}
